import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EmergencyRecordingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"emergency_recording"}/>
}
